export const VERIFIER_STORAGE_KEY = 'code_verifier'
export const TOKEN_STORAGE_KEY = 'token'
export const USER_ID_STORAGE_KEY = 'user_id'
export const STATE_STORAGE_KEY = 'state'
export const ENTITLEMENTS_STORAGE_KEY = 'entitlements'
export const EXPIRY_STORAGE_KEY = 'expiry'
export const RETURN_PATH_STORAGE_KEY = 'oidc_return_path'
export const IS_SHARE_LINK_KEY = 'is_share_link'
export const SHARE_LINK_KEY = 'share_link'